import React from 'react';
import '../../styles/Header.css';
import MenuItem from '../common/MenuItem';

class MiddleMenu extends React.Component {
  render() {
    const {host, menu, imgUrl, path} = this.props;
    return (
      <div className="menu-container middle flex">
        <MenuItem menu={menu} host={host} imgUrl={imgUrl} path={path} />
      </div>
    );
  }
}

export default MiddleMenu;
